import { RejectedTransactions } from "../../../../../../shared/interfaces/services/rejected-credits";
import { parseCurrencyValue } from "../../../../../../shared/utils/parseCurrencyValue";

type RejectedPayment = RejectedTransactions;

export const mapOfRejectedPayments = (rejections: Array<RejectedPayment> = [], isCredit: boolean) => 
  rejections.map(({ 
    descripcioRama, 
    poliza, 
    endoso, 
    asegurado, 
    importe, 
    numeroRechazo,
    motivoRechazo,
    numeroPago, 
  }) => {
    const baseMapping = {
      'Rama': descripcioRama ?? '',
      'Num. Póliza': poliza ?? '',
      'Sup.': endoso ?? '',
      'Asegurado': asegurado ?? '',
      'Moneda Origen': 'PESOS',
      'Importe': parseCurrencyValue(importe) ?? '',
      'Nº de Rechazo': numeroRechazo ?? '',
      'Texto': motivoRechazo ?? '',
      'Número CBU': numeroPago.slice(-6) ?? '',
    };

    return isCredit 
      ? { ...baseMapping, 'N° de Rechazo': numeroRechazo ?? '' } 
      : baseMapping;
  });